import React from "react";
import { Link } from "react-router-dom";

export default function ServiceHero({ service, hideStats = false }) {
    return (
        <section className="service-detail-hero">
            <div className="service-detail-inner">
                <div className="service-detail-bread">
                    <Link to="/">Inicio</Link>
                    <span>/</span>
                    <Link to="/servicios">Servicios Empresariales</Link>
                    <span>/</span>
                    <strong>{service.title}</strong>
                </div>
                <span className="service-hero-tag">Servicio empresarial</span>
                <h1>{service.title}</h1>
                <p>{service.subtitle}</p>
                <div className="service-hero-photo">
                    <img src={service.image} alt={service.imageAlt} />
                </div>
                {!hideStats && service.stats?.length ? (
                    <div className="service-stat-row">
                        {service.stats.map(([value, label]) => (
                            <div className="service-stat" key={value}>
                                <strong>{value}</strong>
                                <span>{label}</span>
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        </section>
    );
}
